import { Paper, Tabs, Tab, Stack, Box } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import {
  EditIconButton,
  AddProcessIconButton,
  DeleteIconButton,
} from '../../../../components/common/button/CustomIconButton';
import useConfirm from '../../../../components/common/useConfirm';
import ModalCustom from '../../../../components/common/Modal';
import AddRackModal from './AddRackModal';
import axios from 'axios';
import { apiConstant } from '../helpers/constant';

const StyledPaper = styled(Paper)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
`;

const StyledBox = styled(Box)`
  flex-grow: 1;
  max-width: calc(100% - 150px);
  overflow: hidden;
`;

const RackTabs = ({
  racksData,
  tabValue,
  setTabValue,
  setUseEffectRender,
}: any) => {
  const [id, setId] = useState(null);
  const [addRackModal, setAddRackModal] = useState(false);
  const [DeleteConfirm, handleDeleteConfirm] = useConfirm(
    'Delete!!!💀',
    'Are you sure you want to Delete? This action is not reversible!'
  );
  const [ChangeTab, handleChangeTab] = useConfirm(
    'Change Tab!!!⚠️',
    'Are you sure you want to change the tab? Please save all changes before switching tabs.🔄'
  );

  const handleDelete = async (item_id: string) => {
    const ans = await handleDeleteConfirm();
    if (!ans) return;
    try {
      const res = await axios.delete(
        `/api/${apiConstant.rackroute}/${item_id}`
      );
      if (res.status !== 200) return;
      setUseEffectRender((prev: any) => !prev);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <StyledPaper elevation={2}>
        <StyledBox>
          <Tabs
            value={tabValue}
            onChange={async (_, newValue) => {
              const ans = await handleChangeTab();
              if (!ans) return;
              setTabValue(newValue);
            }}
            TabIndicatorProps={{
              style: { backgroundColor: '#0ca678' },
            }}
            variant="scrollable"
            scrollButtons="auto"
            textColor="secondary"
          >
            {racksData?.map((rack: any) => (
              <Tab label={`${rack.name}`} key={rack?._id} />
            ))}
          </Tabs>
        </StyledBox>
        <Stack direction="row" alignItems="center" gap={1}>
          <EditIconButton
            tooltipTitle="EDIT"
            onClick={() => {
              setAddRackModal(true);
              setId(racksData?.[tabValue]?._id || null);
            }}
          />
          <AddProcessIconButton
            label="add new rack"
            onClick={() => {
              setAddRackModal(true);
            }}
          />
          {racksData.length > 0 && (
            <DeleteIconButton
              tooltipTitle="Delete current process"
              sx={{ mr: '10px', ml: -0.5 }}
              onClick={() => {
                const item_id = racksData?.[tabValue]?._id || null;
                handleDelete(item_id);
              }}
            />
          )}
        </Stack>
      </StyledPaper>

      <ModalCustom
        title="RACK NAME"
        openModal={addRackModal}
        closeModal={() => {
          setAddRackModal(false);
          setId(null);
        }}
      >
        <AddRackModal
          {...{ id, setId }}
          setIsModal={setAddRackModal}
          setUseEffectRender={setUseEffectRender}
        />
      </ModalCustom>
      <DeleteConfirm isSubmitContent={true} />
      <ChangeTab isSubmitContent={true} />
    </>
  );
};

export default RackTabs;
